
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

// Create a unique error ID to prevent duplicate toasts
const ERROR_TOAST_ID = 'leagues-fetch-error';

// Cache key for leagues query
export const LEAGUES_QUERY_KEY = ['leagues'];

export const useLeaguesQuery = () => {
  return useQuery({
    queryKey: LEAGUES_QUERY_KEY,
    queryFn: async () => {
      try {
        console.log("Fetching leagues data");
        const { data, error } = await supabase
          .from('leagues')
          .select('*')
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Error fetching leagues:', error);
          toast.error('Failed to load leagues', { id: ERROR_TOAST_ID });
          throw error;
        }

        console.log(`Successfully fetched ${data?.length || 0} leagues`);
        return data || [];
      } catch (error) {
        console.error('Exception in leagues query:', error);
        toast.error('Failed to load leagues', { id: ERROR_TOAST_ID });
        throw error;
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes stale time (increased from 5)
    gcTime: 30 * 60 * 1000, // 30 minutes garbage collection (increased from 15)
    refetchOnWindowFocus: false,
  });
};

// Helper function to prefetch leagues data
export const prefetchLeagues = async (queryClient) => {
  if (!queryClient.getQueryData(LEAGUES_QUERY_KEY)) {
    await queryClient.prefetchQuery({
      queryKey: LEAGUES_QUERY_KEY,
      queryFn: async () => {
        const { data, error } = await supabase
          .from('leagues')
          .select('*')
          .order('created_at', { ascending: false });
          
        if (error) throw error;
        return data || [];
      },
      staleTime: 10 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
    });
  }
};
